import Conf from '../../configuration'

import Vue from 'vue'
import VueAmplitude from 'vue-amplitude'

import Storage from '@/helpers/storage'

import gtmFunction from '@/assets/gtmFunction'

import Env from '@/modules/env'
import Tracking from '@/modules/tracking'

export default {

    pageViewAmplitude(vue, page, provider) {

        eventAmplitude(vue, 'screen_view', '', provider, page)

    },

    pageViewGA(vue, page) {

        eventGa('screen_view', {page: vue.$store.getters.page})

    },

    pageViewAll(vue, page, provider) {

        this.pageViewAmplitude(vue, page, provider)
        this.pageViewGA(vue, page)
    },

    clickAll(vue, target, provider, value) {

        this.clickAmplitude(vue, target, provider, value)
        this.clickGA(vue, target, provider, value)
    },

    clickAmplitude(vue, target, provider, value) {

        eventAmplitude(vue, 'click', target, provider, false, value)

    },

    clickGA(vue, target, provider, value) {

        eventGa('click', {target, provider, page: vue.$store.getters.page, value})
    },

    infoAmplitude(vue, target, provider) {

        eventAmplitude(vue, 'info', target, provider)

    },

    infoGa(vue, target, provider, value) {

        eventGa('info', {target, provider, page: vue.$store.getters.page, value})

    },

    infoAll(vue, target, provider, value) {

        eventAmplitude(vue, 'info', target, provider, null, value)

        eventGa('info', {target, provider, page: vue.$store.getters.page, value})

    },

    popupAmplitude: function (vue, target, provider) {

        eventAmplitude(vue, 'popup', target, provider)

    },

    popupGa: function (vue, target, provider) {

        eventGa('popup', {target, provider, page: vue.$store.getters.page})

    },

    popupAll: function (vue, target, provider) {

        this.popupAmplitude(vue, target, provider)
        this.popupGa(vue, target, provider)

    },

    stateAmplitude(vue, target) {

        eventAmplitude(vue, 'state', target)

    },

    firstProvider(vue, provider) {

        if (vue && vue.$amplitude) {
            vue.$amplitude.setUserProperties({'first_provider': provider})
        }

    },

    errorAmplitude: function (vue, message) {

        eventAmplitude(vue, 'error', message)

    },

    accountCreated: function (provider) {

        eventGa('account_created', {provider})

    },

    accountCreatedAmplitude: function (vue, provider) {

        eventAmplitude(vue, 'account_created', null, provider, 'none')

    },

    accountAssociated: function () {

        eventGa('account_associated')

    },

    accountAssociatedAmplitude: function (vue) {

        eventAmplitude(vue, 'account_associated')

    },

    initTracking(vue) {

        // Amplitude
        Vue.use(VueAmplitude, {
            apiKey: Conf.tracking.amplitudeKey,
            config: {
                includeUtm: true,
                includeReferrer: true,
                saveParamsReferrerOncePerSession: false
            }
        })

        const properties = Tracking.getTracking()

        vue.$amplitude.getInstance().setUserProperties(properties)

        // GTM

        const scriptGtm = document.createElement('script')

        scriptGtm.innerHTML = gtmFunction
        document.head.appendChild(scriptGtm)


        // GTAG

        const scriptGtag = document.createElement('script')
        scriptGtag.setAttribute('src', `https://www.googletagmanager.com/gtag/js?id="${Conf.tracking.gtagId}">`)
        document.body.appendChild(scriptGtag)
        window.gtag = function gtag() {

            window.dataLayer.push(arguments)
        }

        window.gtag('js', new Date())

        window.gtag('config', Conf.tracking.gtagId, {
            'send_page_view': false,
            'anonymize_ip': true,
            'optimize_id': Conf.tracking.optimizeId
        })

        const cookieLawPreferences = Storage.getItem('cookieLawPreferences')

        if (cookieLawPreferences) {

            startCookies()
        }

    },

    updateCookies(result) {

        const refresh = Storage.getItem('cookieLawPreferences')

        const now = Date.now()
        result.forEach(cookie => cookie.since = now)
        const preferencesJson = JSON.stringify(result)

        Storage.setItem('cookieLawPreferences', preferencesJson)

        if (refresh) {
            window.location.reload(true)
        } else {
            startCookies()
        }
    }
}

function eventGa(action, {target, provider, page, value} = {}) {

    const options = {
        'event_category': target,
        'page_view': page,
        'event_label': provider,
        'value': value
    }
    if (Storage.getItem('debugTracking') === '*' || Storage.getItem('debugTracking') === 'ga') {
        console.debug(`gtag ${action} ${Object.values(options)}`)
    }

    if (Env.isProd() && gtag) {

        gtag('event', action, options)

    }

}

function eventAmplitude(vue, event, target, provider, page, value) {

    if (vue && vue.$amplitude) {

        const obj = {}

        if (target) {
            obj.event_category = target

        }

        if (provider) {
            obj.event_label = provider
        }

        if (page !== 'none') {
            obj.amplitude_screen = page || vue.$store.getters.page
        }

        if (value) {
            obj.value = value
        }

        if (Storage.getItem('debugTracking') === '*' || Storage.getItem('debugTracking') === 'amplitude') {
            console.debug(`amplitude ${event} ${obj.amplitude_screen} ${obj.event_category ? obj.event_category : ''}  ${obj.event_label ? obj.event_label : ''}`)
        }


        if (Env.isProd()) {
            try {
                vue.$amplitude.getInstance().logEvent(event, obj)
            } catch (ignored) {
                // do nothing
            }
        }

    }
}

function startCookies() {

    const cookieLawPreferences = Storage.getItem('cookieLawPreferences')

    const cookieLawPreferencesObj = JSON.parse(cookieLawPreferences) || []

    const cookieLawRefuse = cookieLawPreferencesObj.filter(item => !item.active)
    const cookieLawAccept = cookieLawPreferencesObj.filter(item => item.active)

    let cookieLawRefuseStr = ''
    let cookieLawAcceptStr = ''

    cookieLawRefuse.forEach(item => cookieLawRefuseStr = `${cookieLawRefuseStr}-${item.name}`)
    cookieLawAccept.forEach(item => cookieLawAcceptStr = `${cookieLawAcceptStr}-${item.name}`)

    eventGa(`cookie-law-refuse-${cookieLawRefuseStr}-`)
    eventGa(`cookie-law-accept-${cookieLawAcceptStr}-`)
}
